var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88305 4.59949L5.37305 8.13757H8.88305V4.59949Z",
    fill: "#1b4597"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6026 17.2453L18.6289 18.2268L22.0654 21.6908L23.0391 20.7093L19.6026 17.2453Z",
    fill: "#1b4597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8227 17.8537C13.9317 17.8537 13.1217 17.5816 12.4197 17.1461H6.85773V16.3841H11.4747C10.9347 15.8125 10.5567 15.0777 10.3677 14.2884H6.85773V13.5264H10.2597C10.2597 13.4447 10.2597 13.3631 10.2597 13.2542C10.2597 12.601 10.3947 11.9751 10.6377 11.4308H6.85773V10.6687H11.0697C11.9067 9.47121 13.2567 8.68194 14.8227 8.68194C16.4157 8.68194 17.8197 9.52564 18.6297 10.7776V3.70142H9.63873V8.9541H4.42773V23.5963H18.6297V15.7853C17.8197 17.01 16.4157 17.8537 14.8227 17.8537Z",
    fill: "#1b4597"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0686 15.8942C12.7706 16.629 13.7426 17.0917 14.8226 17.0917C16.9286 17.0917 18.6296 15.3771 18.6296 13.2542C18.6296 11.1314 16.9286 9.41677 14.8226 9.41677C13.2566 9.41677 11.9066 10.3966 11.3126 11.7574H15.3086V13.1454H11.0156C11.0156 13.1726 11.0156 13.1998 11.0156 13.227C11.0156 13.6625 11.0966 14.0979 11.2316 14.479H15.3086V15.867H12.0686V15.8942Z",
    fill: "#1b4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.2b3ad6273ef3d041c4eb8a4e1d6ac0c3.svg";
export { ForwardRef as ReactComponent };